import { Injectable } from '@angular/core';
import { ConfigService } from './../shared/services/config/config.service';
import { HttpClient } from '@angular/common/http';
import { Observable ,  of } from 'rxjs';
import { switchMap ,  catchError } from 'rxjs/operators';
import urlJoin from 'url-join';
import { ROUTE_TOKEN_GATEWAY_URL } from '../shared/interceptors/gateway-url.interceptor';

export interface EntitlementsManager {
  isEntitled (reqEntitlements: string[]): boolean;
  loadEntitlements();
  clearEntitlementData();
}

@Injectable()
export class EntitlementsService implements EntitlementsManager {
  constructor(
    private configService: ConfigService,
    private http: HttpClient) { }

    private static ENTITLEMENTS_KEY = 'entitlementsData';

    private getEntitlements(): string[] {
        const cached: string[] = JSON.parse(sessionStorage.getItem(EntitlementsService.ENTITLEMENTS_KEY));
        return cached;
    }

    public isEntitled(reqEntitlements: string[]): boolean {
        if (!this.configService.entitlementsEnabled || !(reqEntitlements || []).length) {
            return true;
        }

        const entitlements = new Set(this.getEntitlements());
        if (entitlements == null) {
            return false;
        }

        return reqEntitlements.every(e => entitlements.has(e));
    }

  public isLoaded(): boolean {
    const entitlements = this.getEntitlements();
    return entitlements != null;
  }

  public loadEntitlements(): Observable<boolean> {
        if (!this.configService.entitlementsEnabled) {
            return of(true);
        }

        const uri = urlJoin(ROUTE_TOKEN_GATEWAY_URL, '/payment/v1/services/entitlements');
        const entitlements = this.http.get<string[]>(uri);

        return entitlements.pipe(switchMap(entitlementStrings => {
            if (entitlementStrings != null) {
                sessionStorage.setItem(EntitlementsService.ENTITLEMENTS_KEY, JSON.stringify(entitlementStrings));
                return of(true);
            } else {
                this.clearEntitlementData();
                return of(false);
            }
        }), catchError(error => {
            this.clearEntitlementData();
            return of(false);
        }));
    }

    public clearEntitlementData() {
        if (sessionStorage.getItem(EntitlementsService.ENTITLEMENTS_KEY) != null) {
            sessionStorage.removeItem(EntitlementsService.ENTITLEMENTS_KEY);
        }
    }
}
